export const PERPS_V1_VIEWS_PERMISSION = 'perps-v1:views';
export const PERPS_V1_PINS_PERMISSION = 'perps-v1:pins';
export const PERPS_V1_SECTORS_PERMISSION = 'perps-v1:sectors';
export const PERPS_V1_SYMBOLS_PERMISSION = 'perps-v1:symbols';
export const PERPS_V1_PRESETS_PERMISSION = 'perps-v1:favorite-presets';
